var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"toggleable":"lg"}},[_c('div',{staticClass:"site-title"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n        DMR LIVE\n      ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }